module.exports = __webpack_public_path__ + "images/help/video-me-a5819cf8f8fa7bacee2308e26868d3e8.png";